import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useSnackbar } from 'notistack'
import { addTeacher } from 'app/redux/store/features/teachers'
import { defaultTeacher } from './defaultTeacher'
import AddTeacherForm from './AddTeacherForm'
const AddTeacher = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { enqueueSnackbar } = useSnackbar()

    const [teacherData] = useState({ ...defaultTeacher })
    const [apiCallInProgress, setApiCallInProgress] = useState(false)

    const { loading, error } = useSelector((state) => state.teachers)

    useEffect(() => {
        if (!apiCallInProgress || loading) return
        setApiCallInProgress(false)
        if (error) handleError(error)
        else {
            enqueueSnackbar('Teacher added successfully', {
                variant: 'success',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
            navigate('/security/teachers', { state: { navigateFrom: 'add-teacher' } })
        }
    }, [loading])

    function handleError(error) {
        if (error.status === '401') {
            navigate('/profile/signout')
        } else if (error.detail) {
            enqueueSnackbar(error.detail, {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
        } else {
            enqueueSnackbar(error, {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
        }
    }

    const onAddTeacher = async () => {
        setApiCallInProgress(true)
        dispatch(addTeacher({ ...teacherData }))
    }

    return (
        <React.Fragment>
            <AddTeacherForm teacherData={teacherData} addTeacher={onAddTeacher} />
        </React.Fragment>
    )
}

export default AddTeacher
